
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.3 13.43a1 1 0 00-1.25.65A7.14 7.14 0 0112.18 19 7.1 7.1 0 015 12a7.1 7.1 0 017.18-7 7.26 7.26 0 014.65 1.67l-2.17-.36a1 1 0 00-1.137 1.221 1 1 0 00.817.759l4.24.7h.17a1 1 0 00.34-.06.33.33 0 00.1-.06.78.78 0 00.2-.11l.09-.11c0-.05.09-.09.13-.15.04-.06 0-.1.05-.14.028-.058.051-.118.07-.18l.75-4a1.017 1.017 0 10-2-.38l-.27 1.45A9.21 9.21 0 0012.18 3 9.1 9.1 0 003 12a9.1 9.1 0 009.18 9A9.12 9.12 0 0021 14.68a1.001 1.001 0 00-.7-1.25z","fill":"#fff"}})])
          )
        }
      }
    